import React from 'react';
import clsx from 'clsx';

export const Radio = ({value, name, group, classes, radio, setRadio, open = false}) => (
  <label className={classes.label}>
    <input
      key={value}
      className={classes.inputValue}
      type='radio'
      name={group}
      value={value}
      onChange={v => setRadio(v.target.value)}
      checked={radio === value ? 'checked' : false}
    />
    <span className={clsx(classes.inputName, {open})}>{name}</span>
  </label>
);

